import { Selection } from '@typeRoots/common/checkListModal';
import { EnhancedSelection } from '@typeRoots/common/freight';

const DEFAULT_SELECTION_VALUES = { percentageOfHauls: 0, active: true };

export const calculateSum = (selection: EnhancedSelection[]): number =>
  selection.reduce((sum, item) => sum + item.percentageOfHauls, 0);

export const prepareEnhancedSelection = (
  newSelection: Selection[],
  previousSelection: EnhancedSelection[],
): EnhancedSelection[] =>
  newSelection.map((item) => {
    const existingItem = previousSelection.find(
      (prevItem) => prevItem.type === item.type && prevItem.subtype.value === item.subtype.value,
    );

    return existingItem ? { ...existingItem } : { ...item, ...DEFAULT_SELECTION_VALUES };
  });
